import React, { FunctionComponent } from 'react';

export const StackHeightSvg: FunctionComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="500" height="374" viewBox="0 0 500 374">
      <g id="Page-1" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="10.2”-iPad" transform="translate(-33 -1047)">
          <g id="stack_height" transform="translate(33 1047)">
            <g id="Background_Complete" fillRule="nonzero">
              <g id="Group" fill="#EBEBEB">
                <path id="Rectangle" d="M0 328.4H500V329.4H0z"></path>
                <path id="Rectangle" d="M416.78 344.49H449.9V345.49H416.78z"></path>
                <path id="Rectangle" d="M322.53 347.21H331.21999999999997V348.21H322.53z"></path>
                <path id="Rectangle" d="M396.59 335.21H415.78V336.21H396.59z"></path>
                <path id="Rectangle" d="M52.46 336.89H95.65V337.89H52.46z"></path>
                <path id="Rectangle" d="M104.56 336.89H110.89V337.89H104.56z"></path>
                <path id="Rectangle" d="M131.47 341.11H225.15V342.11H131.47z"></path>
              </g>
              <g id="Group" transform="translate(236 30)">
                <path id="Rectangle" fill="#E0E0E0" d="M22.38 56.44H194.28V179.89H22.38z"></path>
                <path id="Rectangle" fill="#EBEBEB" d="M20.38 56.45H192.29V179.9H20.38z"></path>
                <path
                  id="Rectangle"
                  fill="#FAFAFA"
                  d="M51.005 35.825H161.665V197.735H51.005z"
                  transform="rotate(90 106.335 116.78)"
                ></path>
                <g fill="#E0E0E0" transform="translate(36 69)">
                  <path
                    id="Path"
                    d="M2.57 22.12c-.05 0-.11 0-.17-.03a.506.506 0 01-.31-.64L6.21 9.71c.07-.2.24-.3.48-.33.21 0 .4.14.47.35l3.8 11.74a.51.51 0 01-.32.63.5.5 0 01-.63-.32L6.67 11.46 3.04 21.8c-.07.21-.27.33-.47.33v-.01z"
                  ></path>
                  <path
                    id="Path"
                    d="M8.91 17.25h-3.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3.5c.28 0 .5.22.5.5s-.22.5-.5.5zM15.63 21.79c-.75 0-1.46-.44-2.12-1.31-.8-1.06-1.01-1.97-.61-2.71.9-1.7 4.7-1.54 5.13-1.51.28.02.49.25.47.53-.02.28-.25.49-.53.47-1.16-.06-3.71.09-4.19.99-.24.46.15 1.15.53 1.64.51.68 1.01.98 1.48.9 1.19-.2 2.42-2.68 2.92-4.19a.497.497 0 01.96.24c-.15.91-.3 3.61.97 3.99a.5.5 0 01.33.62c-.08.26-.36.42-.62.33-1.12-.34-1.56-1.45-1.71-2.55-.64 1.16-1.56 2.36-2.69 2.55-.11.02-.22.03-.33.03l.01-.02z"
                  ></path>
                  <path
                    id="Shape"
                    d="M3.5 43.48a.46.46 0 01-.33-.13.48.48 0 01-.17-.37V29.75c-.62.05-1.15.1-1.54.15a.503.503 0 01-.56-.43c-.04-.27.16-.52.43-.56.72-.09 7.07-.87 9.03.85.41.36.63.83.63 1.34 0 1.7-1.43 2.81-2.83 3.49 1.47.17 3.12.59 3.92 1.61.35.44.68 1.2.34 2.31-1.27 4.09-8.55 4.93-8.86 4.96h-.05l-.01.01zM4 29.69v12.72c1.67-.27 6.57-1.31 7.46-4.19.18-.57.12-1.03-.17-1.4-1.02-1.3-4.57-1.39-5.86-1.31-.26 0-.49-.17-.53-.43-.03-.26.14-.5.4-.55 1.3-.26 4.68-1.39 4.68-3.42 0-.23-.09-.42-.29-.59-.93-.82-3.54-.92-5.7-.82l.01-.01zM18.54 44.1c-.76 0-1.6-.19-2.48-.64a.5.5 0 01-.22-.67.49.49 0 01.67-.22c2.03 1.03 3.71.43 4.26-.65.46-.89 0-1.85-1.16-2.45-.9-.46-1.69-.46-2.43.03-1.24.81-1.88 2.65-1.98 3.25 0 .04 0 .09-.01.12v.03c-.08.57-.21.58-.42.61a.54.54 0 01-.55-.43c-.03-.14-.02-.36.04-.63.03-1.49 0-6.1-.05-9.07 0-.28.22-.5.49-.51.27 0 .5.22.5.49.04 3.08.07 5.22.07 6.71.32-.48.71-.93 1.16-1.27 1.09-.82 2.34-.89 3.64-.22 1.93 1 2.19 2.63 1.59 3.79-.51 1-1.66 1.72-3.12 1.72v.01z"
                  ></path>
                  <path
                    id="Path"
                    d="M6.57 64.08c-1.61 0-3.2-1.08-4.28-2.45-1.73-2.2-2.49-5.7-.08-8.19 1.61-1.66 3.17-2.45 4.62-2.34 1.6.12 2.44 1.29 2.48 1.34.16.23.11.54-.12.7a.5.5 0 01-.7-.12c-.03-.04-.63-.85-1.76-.92-1.15-.08-2.43.61-3.81 2.04-2 2.07-1.37 4.94.15 6.88 1.21 1.54 3.15 2.66 4.78 1.71 3.35-1.96 3.71-2.83 3.72-2.86.04-.27.28-.44.56-.4.27.04.46.32.42.59-.05.35-.55 1.4-4.19 3.53-.58.34-1.19.49-1.79.49z"
                  ></path>
                  <path
                    id="Shape"
                    d="M17.68 64.29c-1.99 0-3.25-1.19-3.48-3.32-.16-1.52.17-2.57.98-3.11 1.57-1.05 4.22.35 4.51.51.24.13.33.44.2.68-.13.24-.44.33-.68.2-.66-.36-2.57-1.16-3.48-.56-.48.32-.66 1.05-.54 2.18.14 1.35.72 2.12 1.77 2.35 1.62.36 3.7-.69 3.99-1.08.04-.23.24-.4.48-.4s.5.21.51.49c.02.91-2.23 1.94-3.93 2.06-.12 0-.23.01-.34.01l.01-.01z"
                  ></path>
                  <path
                    id="Path"
                    d="M5.25 86.1c-.88 0-1.5-.09-1.56-.1a.503.503 0 01-.42-.49V73.19c0-.28.22-.5.5-.5s.5.22.5.5v11.87c1.06.09 3.85.16 5.65-1.32 1.03-.85 1.59-2.1 1.65-3.72.12-2.97-1.31-4.8-2.53-5.82-2.06-1.71-4.98-2.36-6.61-1.98a.503.503 0 01-.22-.98c1.84-.42 5.08.21 7.47 2.19 1.4 1.16 3.03 3.25 2.89 6.63-.08 1.92-.76 3.41-2.02 4.45-1.62 1.33-3.82 1.59-5.29 1.59h-.01zM19.15 86.16c-2.38 0-3.89-1.28-4.2-2.71-.24-1.12.28-2.47 1.98-2.97.87-.25 1.7-.17 2.45.26.66.38 1.18.97 1.57 1.58v-9c0-.28.22-.5.5-.5s.5.22.5.5v11.34c0 .25-.19.46-.44.5a.509.509 0 01-.55-.37c0-.02-.64-2.36-2.08-3.17-.51-.29-1.06-.34-1.67-.17-.97.28-1.47.97-1.29 1.8.26 1.18 1.75 2.2 4.11 1.86.28-.03.53.15.57.42.04.27-.15.53-.42.57-.36.05-.7.08-1.03.08v-.02zM36.86 89.24h-.04a.497.497 0 01-.46-.54c2.74-38.04.03-87.01 0-87.5-.02-.28.2-.51.47-.53.28-.01.51.19.53.47.03.49 2.74 49.52 0 87.62-.02.26-.24.46-.5.46v.02zM140.66 67.35H47.4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h93.26c.28 0 .5.22.5.5s-.22.5-.5.5zM52.42 64.29c-.12 0-.23-.04-.33-.12a.505.505 0 01-.05-.71c.68-.79 16.74-19.36 21.78-21.93 5.24-2.67 20.49 17.43 22.21 19.73.17.22.12.53-.1.7-.22.17-.54.12-.7-.1-6.31-8.43-17.58-21.16-20.95-19.44-4.87 2.48-21.31 21.5-21.48 21.69-.1.11-.24.17-.38.17v.01zM138.22 62.06c-.14 0-.28-.06-.38-.17-4.75-5.52-17.87-19.84-21.54-19.61-3.7.19-14.93 11.64-18.94 16.04-.19.2-.5.22-.71.03-.2-.19-.22-.5-.03-.71.6-.66 14.77-16.11 19.63-16.36 4.87-.23 20.57 17.89 22.35 19.96.18.21.16.52-.05.71-.09.08-.21.12-.33.12v-.01zM88.61 48.68c-.12 0-.24-.04-.34-.13-.2-.19-.21-.5-.03-.71.16-.18 4.05-4.31 8.76-4.13 2.45.1 4.65 1.36 6.54 3.76.17.22.13.53-.08.7-.22.17-.53.13-.7-.08-1.69-2.15-3.64-3.29-5.79-3.37-4.25-.18-7.95 3.77-7.99 3.81-.1.11-.23.16-.37.16v-.01zM88.61 44.1c-.19 0-.36-.1-.45-.28l-2.47-5.11a.5.5 0 11.9-.44l2.47 5.11a.5.5 0 01-.45.72zM95.88 40.24h-.1a.495.495 0 01-.39-.59c.3-1.55 0-6.19 0-6.24-.02-.28.19-.51.47-.53.27 0 .51.19.53.47.01.2.32 4.82 0 6.5-.05.24-.26.4-.49.4l-.02-.01zM103.15 40.24a.496.496 0 01-.4-.8l3.41-4.42c.17-.22.48-.26.7-.09.22.17.26.48.09.7l-3.41 4.42c-.1.13-.25.19-.4.19h.01z"
                  ></path>
                  <path
                    id="Shape"
                    d="M138.22 17.25h-30.23c-.19 0-.36-.11-.45-.27a.489.489 0 01.04-.52c2.73-3.72 6.88-4.11 8.21-4.14.41-1.56 2.13-7.14 5.47-7.14 3.01 0 5.62 3.51 6.56 4.94.66-.62 2-1.54 4.39-1.48 3.56.03 6.19 7.14 6.47 7.96.05.15.03.32-.06.46-.09.13-.25.21-.41.21l.01-.02zm-29.17-1h28.44c-.93-2.32-3.09-6.6-5.29-6.62-2.98-.05-3.99 1.52-4.03 1.58-.09.15-.27.24-.43.23a.5.5 0 01-.42-.25c-.03-.05-2.94-5.02-6.06-5.02-2.5 0-4.16 4.88-4.59 6.76-.05.24-.27.39-.51.39-.05 0-4.2-.18-7.11 2.93zM79.72 28.58c-.18 0-.36-.1-.45-.28-.08-.17-.18-.32-.3-.47.04.07.06.15.06.24 0 .28-.22.5-.5.5h-29.8c-.24 0-.45-.18-.49-.42 0-.06-.22-1.4.71-2.37.65-.68 1.66-.98 3.01-.89.09-1.01.48-3.22 2.05-4.76 1.13-1.11 2.64-1.66 4.49-1.63 4.94.09 7.53 2.88 8.46 4.17.58-.61 1.74-1.46 3.82-1.55 2.48-.14 3.48 2.12 3.7 3.62 1.18.2 4.6.94 5.69 3.12.12.25.02.55-.22.67-.07.04-.15.05-.22.05h-.01zm-30.5-1h29.32c.11 0 .22.04.3.1-1.47-1.59-4.83-2-4.87-2.01a.501.501 0 01-.44-.46c0-.13-.27-3.19-2.71-3.09-2.66.12-3.44 1.63-3.45 1.64-.08.17-.25.27-.44.28a.55.55 0 01-.45-.26c-.09-.17-2.33-4.17-8.01-4.27-1.58-.03-2.84.42-3.77 1.33-1.76 1.73-1.79 4.57-1.79 4.6 0 .14-.06.28-.17.37-.11.1-.25.14-.39.12-1.27-.16-2.2.03-2.69.54-.33.34-.43.78-.45 1.1l.01.01z"
                  ></path>
                  <path
                    id="Path"
                    d="M76.15 90.56a.505.505 0 01-.38-.83l17.88-21.36c.18-.21.49-.24.7-.06.21.18.24.49.06.7L76.53 90.37c-.1.12-.24.18-.38.18v.01zM98.3 90.56c-.25 0-.47-.19-.5-.45l-2.28-21.36c-.03-.27.17-.52.44-.55.28-.03.52.17.55.44L98.79 90c.03.27-.17.52-.44.55h-.05v.01z"
                  ></path>
                </g>
                <g transform="translate(41 171)">
                  <path
                    id="Path"
                    fill="#E6E6E6"
                    d="M3.13.18h17.89c.8 0 1.44.65 1.44 1.44v3.62H1.69V1.62c0-.8.65-1.44 1.44-1.44z"
                  ></path>
                  <path id="Rectangle" fill="#E0E0E0" d="M0.4 2.33H23.74V7.1H0.4z"></path>
                </g>
                <g transform="translate(115 150)">
                  <g transform="translate(1)">
                    <path
                      id="Rectangle"
                      fill="#EBEBEB"
                      d="M1.225 4.02H2.805V19.84H1.225z"
                      transform="rotate(-2.34 2.015 11.93)"
                    ></path>
                    <path id="Path" fill="#E6E6E6" d="M0.85 0.98L0.87 4.25 2.57 4.18 2.32 0.92z"></path>
                    <path
                      id="Rectangle"
                      fill="#E6E6E6"
                      d="M0.791 3.999H2.661V4.9990000000000006H0.791z"
                      transform="rotate(-2.34 1.726 4.449)"
                    ></path>
                  </g>
                  <g transform="translate(5 1)">
                    <path
                      id="Rectangle"
                      fill="#EBEBEB"
                      d="M1.671 3.984H3.2510000000000003V19.804000000000002H1.671z"
                      transform="rotate(7.45 2.46 11.894)"
                    ></path>
                    <path id="Path" fill="#E6E6E6" d="M3.16 0.93L2.62 4.15 4.3 4.37 4.61 1.12z"></path>
                    <path
                      id="Rectangle"
                      fill="#E6E6E6"
                      d="M2.492 4.063H4.362V5.063H2.492z"
                      transform="rotate(7.45 3.427 4.513)"
                    ></path>
                  </g>
                  <g transform="translate(10)">
                    <path
                      id="Rectangle"
                      fill="#E6E6E6"
                      d="M0.878 4.012H2.458V19.832H0.878z"
                      transform="rotate(-2.33 1.668 11.922)"
                    ></path>
                    <path id="Path" fill="#F0F0F0" d="M0.5 0.98L0.52 4.25 2.22 4.18 1.97 0.92z"></path>
                    <path
                      id="Rectangle"
                      fill="#F0F0F0"
                      d="M0.435 4.011H2.305V5.011H0.435z"
                      transform="rotate(-2.33 1.37 4.46)"
                    ></path>
                  </g>
                  <g transform="translate(3)">
                    <path
                      id="Rectangle"
                      fill="#E6E6E6"
                      d="M1.308 4.001H2.888V19.821H1.308z"
                      transform="rotate(-7.07 2.098 11.91)"
                    ></path>
                    <path id="Path" fill="#F0F0F0" d="M0.02 1.11L0.31 4.36 1.99 4.15 1.48 0.93z"></path>
                    <path
                      id="Rectangle"
                      fill="#F0F0F0"
                      d="M0.244 4.06H2.114V5.06H0.244z"
                      transform="rotate(-7.07 1.18 4.51)"
                    ></path>
                  </g>
                  <path id="Rectangle" fill="#E0E0E0" d="M0.72 11.3H13.58V28.1H0.72z"></path>
                  <path id="Rectangle" fill="#EBEBEB" d="M3.02 11.3H13.57V28.1H3.02z"></path>
                </g>
                <g id="Path">
                  <path
                    fill="#E0E0E0"
                    d="M.92.71h182.82v6.36c0 .7-.56 1.26-1.26 1.26H2.18c-.7 0-1.26-.56-1.26-1.26V.71z"
                    transform="translate(11 175)"
                  ></path>
                  <path
                    fill="#E0E0E0"
                    d="M.92.71h182.82v6.36c0 .7-.56 1.26-1.26 1.26H2.18c-.7 0-1.26-.56-1.26-1.26V.71z"
                    opacity="0.2"
                    transform="translate(11 175)"
                  ></path>
                  <path
                    fill="#EBEBEB"
                    d="M.92.71h172.82v6.36c0 .7-.56 1.26-1.26 1.26H2.18c-.7 0-1.26-.56-1.26-1.26V.71z"
                    transform="translate(11 175)"
                  ></path>
                </g>
                <g transform="translate(0 238)">
                  <path
                    id="Path"
                    fill="#EBEBEB"
                    d="M181.57 0.83L175.29 0.83 24.49 0.83 24.49 19.08 12.09 19.08 12.09 37.48 0.13 37.48 0.13 59.93 12.09 59.93 24.49 59.93 150.93 59.93 162.89 59.93 175.29 59.93 181.57 59.93 192.28 59.93 192.28 37.48 192.28 19.08 192.28 0.83z"
                  ></path>
                  <path
                    id="Path"
                    fill="#F5F5F5"
                    d="M175.29 0.83L175.29 19.08 162.89 19.08 162.89 37.48 150.93 37.48 150.93 59.93 162.89 59.93 175.29 59.93 192.28 59.93 192.28 37.48 192.28 19.08 192.28 0.83z"
                  ></path>
                  <path id="Rectangle" fill="#E0E0E0" d="M24.49 12.16H175.29000000000002V19.07H24.49z"></path>
                  <path id="Rectangle" fill="#E0E0E0" d="M12.09 30.38H162.89000000000001V37.48H12.09z"></path>
                </g>
              </g>
            </g>
            <g id="Shadow" fill="#F5F5F5" fillRule="nonzero" transform="translate(56 350)">
              <ellipse id="_Path_" cx="194" cy="12.24" rx="193.89" ry="11.32"></ellipse>
            </g>
            <g id="Plant" fillRule="nonzero" transform="translate(69 265)">
              <g id="Group">
                <path
                  id="Path"
                  fill="#407BFF"
                  d="M18.24 73.56s4.75-10.36-.68-20.58c-5.43-10.22-7-12.62-3.54-14.72 3.46-2.1 5.05 8.17 5.05 8.17s2.92-7.06.51-14.45-3.92-19.43-.63-20.72c3.29-1.29.63 15.02 3.48 20.58 0 0 2.4-6.19 2.79-12.13.39-5.94-.22-15.42 2.38-17.85 2.6-2.43 4.26-.75 1.71 12.35s-2.53 23.75-2.53 23.75 5.64-17.19 9.42-17.69c3.78-.5 3.78 5.06.54 9.89-3.24 4.83-9.48 13.48-10.51 17.93 0 0 6.19-12.93 11.75-8.97 5.57 3.96-4.84 11.78-9.48 14.6-4.64 2.82-7.86 20.52-7.86 20.52l-2.39-.68h-.01z"
                ></path>
                <path
                  id="Path"
                  fill="#000"
                  d="M18.24 73.56s4.75-10.36-.68-20.58c-5.43-10.22-7-12.62-3.54-14.72 3.46-2.1 5.05 8.17 5.05 8.17s2.92-7.06.51-14.45-3.92-19.43-.63-20.72c3.29-1.29.63 15.02 3.48 20.58 0 0 2.4-6.19 2.79-12.13.39-5.94-.22-15.42 2.38-17.85 2.6-2.43 4.26-.75 1.71 12.35s-2.53 23.75-2.53 23.75 5.64-17.19 9.42-17.69c3.78-.5 3.78 5.06.54 9.89-3.24 4.83-9.48 13.48-10.51 17.93 0 0 6.19-12.93 11.75-8.97 5.57 3.96-4.84 11.78-9.48 14.6-4.64 2.82-7.86 20.52-7.86 20.52l-2.39-.68h-.01z"
                  opacity="0.2"
                ></path>
                <path
                  id="Path"
                  fill="#407BFF"
                  d="M21.99 77.81s-4.63-10.43.92-20.57 7.15-12.52 3.72-14.66c-3.43-2.14-5.14 8.1-5.14 8.1s-2.83-7.11-.33-14.46c2.5-7.36 4.15-19.37.88-20.71-3.27-1.34-.81 15.01-3.73 20.52 0 0-2.32-6.22-2.65-12.17-.33-5.95.41-15.41-2.16-17.88-2.57-2.47-4.25-.81-1.86 12.33 2.39 13.14 2.25 23.79 2.25 23.79S8.46 24.83 4.68 24.27c-3.78-.56-3.84 5.01-.66 9.88 3.18 4.88 9.32 13.62 10.29 18.08 0 0-6.03-13.02-11.64-9.14-5.61 3.88 4.7 11.85 9.31 14.74 4.61 2.89 7.62 20.63 7.62 20.63l2.4-.65h-.01z"
                ></path>
                <path id="Path" fill="#263238" d="M0.66 70.38L38.87 70.38 35.77 97.72 3.75 97.72z"></path>
              </g>
            </g>
            <g id="Height_meter" fillRule="nonzero" transform="translate(108 46)">
              <g id="Group">
                <g id="Path">
                  <path
                    fill="#407BFF"
                    d="M42.99.26C19.62.26.68 19.2.68 42.57v252.14h84.63V42.58C85.31 19.21 66.37.27 43 .27l-.01-.01z"
                    transform="translate(30 22)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M42.99.26C19.62.26.68 19.2.68 42.57v252.14h84.63V42.58C85.31 19.21 66.37.27 43 .27l-.01-.01z"
                    opacity="0.7"
                    transform="translate(30 22)"
                  ></path>
                </g>
                <g id="Path">
                  <path
                    fill="#407BFF"
                    d="M.06 25.85a5.898 5.898 0 017.59-5.65c-.09-.59-.13-1.2-.13-1.81 0-6.9 5.59-12.49 12.49-12.49.79 0 1.55.08 2.3.22C24.23 2.98 27.68.87 31.63.87c5.98 0 10.83 4.81 10.92 10.77h.18c5.56 0 10.06 4.51 10.06 10.06 0 5.55-4.51 10.06-10.06 10.06H5.78c-3.18-.1-5.73-2.7-5.73-5.9l.01-.01z"
                    transform="translate(75 42)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M.06 25.85a5.898 5.898 0 017.59-5.65c-.09-.59-.13-1.2-.13-1.81 0-6.9 5.59-12.49 12.49-12.49.79 0 1.55.08 2.3.22C24.23 2.98 27.68.87 31.63.87c5.98 0 10.83 4.81 10.92 10.77h.18c5.56 0 10.06 4.51 10.06 10.06 0 5.55-4.51 10.06-10.06 10.06H5.78c-3.18-.1-5.73-2.7-5.73-5.9l.01-.01z"
                    opacity="0.5"
                    transform="translate(75 42)"
                  ></path>
                </g>
                <g id="Path">
                  <path
                    fill="#407BFF"
                    d="M.18 14.66c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0117.59.89c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H3.34a3.258 3.258 0 01-3.16-3.25v-.02z"
                    transform="translate(34 116)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M.18 14.66c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0117.59.89c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H3.34a3.258 3.258 0 01-3.16-3.25v-.02z"
                    opacity="0.5"
                    transform="translate(34 116)"
                  ></path>
                </g>
                <g id="Path">
                  <path
                    fill="#407BFF"
                    d="M.18 19.3a4.426 4.426 0 015.7-4.24c-.06-.44-.1-.9-.1-1.36a9.38 9.38 0 0111.11-9.22 8.187 8.187 0 017-3.94c4.49 0 8.13 3.61 8.2 8.08h.14a7.56 7.56 0 017.56 7.56c0 4.18-3.38 7.56-7.56 7.56H4.49a4.432 4.432 0 01-4.3-4.43l-.01-.01z"
                    transform="translate(43 9)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M.18 19.3a4.426 4.426 0 015.7-4.24c-.06-.44-.1-.9-.1-1.36a9.38 9.38 0 0111.11-9.22 8.187 8.187 0 017-3.94c4.49 0 8.13 3.61 8.2 8.08h.14a7.56 7.56 0 017.56 7.56c0 4.18-3.38 7.56-7.56 7.56H4.49a4.432 4.432 0 01-4.3-4.43l-.01-.01z"
                    opacity="0.5"
                    transform="translate(43 9)"
                  ></path>
                </g>
                <g id="Path">
                  <path
                    fill="#407BFF"
                    d="M.9 14.5c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0118.31.73c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H4.06A3.258 3.258 0 01.9 14.52v-.02z"
                    transform="translate(8 164)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M.9 14.5c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0118.31.73c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H4.06A3.258 3.258 0 01.9 14.52v-.02z"
                    opacity="0.5"
                    transform="translate(8 164)"
                  ></path>
                </g>
                <g id="Path">
                  <path
                    fill="#407BFF"
                    d="M.16 22.7a5.185 5.185 0 016.68-4.97c-.08-.52-.12-1.05-.12-1.59 0-6.07 4.92-10.99 10.99-10.99.69 0 1.37.07 2.03.19C21.43 2.57 24.47.72 27.95.72c5.26 0 9.53 4.23 9.61 9.48h.16c4.89 0 8.86 3.97 8.86 8.86 0 4.89-3.97 8.86-8.86 8.86H5.2C2.4 27.83.15 25.55.15 22.73l.01-.03z"
                    transform="translate(0 44)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M.16 22.7a5.185 5.185 0 016.68-4.97c-.08-.52-.12-1.05-.12-1.59 0-6.07 4.92-10.99 10.99-10.99.69 0 1.37.07 2.03.19C21.43 2.57 24.47.72 27.95.72c5.26 0 9.53 4.23 9.61 9.48h.16c4.89 0 8.86 3.97 8.86 8.86 0 4.89-3.97 8.86-8.86 8.86H5.2C2.4 27.83.15 25.55.15 22.73l.01-.03z"
                    opacity="0.5"
                    transform="translate(0 44)"
                  ></path>
                </g>
                <g id="rocket" transform="translate(8)">
                  <g id="Group" transform="translate(9 102)">
                    <path id="Path" fill="#263238" d="M30.99 0.98L40.72 214.72 0.96 214.72 11.32 0.98z"></path>
                    <path
                      id="Path"
                      fill="#FAFAFA"
                      d="M30.99 0.98L40.72 214.72 0.96 214.72 11.32 0.98z"
                      opacity="0.8"
                    ></path>
                    <path
                      id="Path"
                      fill="#FAFAFA"
                      d="M6.37 214.29L13.5 80.56 15.5 114.36 21.16 21.5 28.32 104.51 28.32 46.94 35.3 214.72z"
                      opacity="0.3"
                    ></path>
                  </g>
                  <g id="Group" transform="translate(15 84)">
                    <path
                      id="Path"
                      fill="#407BFF"
                      d="M21.71.08s7.71 9.76 7.52 17.07c-.19 7.31-2.97 9.57-2.97 9.57l.4-4.74s-1.64 8.76-8.93 14.03l-2.64-4.82s-.89 5.34 0 8.31c0 0-9.33-5.39-10.15-12.78l-1.03 3.11S-.24 22.88.55 16.16C1.34 9.44 7.68.93 7.68.93L21.72.07l-.01.01z"
                    ></path>
                    <path
                      id="Path"
                      fill="#FAFAFA"
                      d="M21.71.08s7.71 9.76 7.52 17.07c-.19 7.31-2.97 9.57-2.97 9.57l.4-4.74s-1.64 8.76-8.93 14.03l-2.64-4.82s-.89 5.34 0 8.31c0 0-9.33-5.39-10.15-12.78l-1.03 3.11S-.24 22.88.55 16.16C1.34 9.44 7.68.93 7.68.93L21.72.07l-.01.01z"
                      opacity="0.2"
                    ></path>
                    <path
                      id="Path"
                      fill="#FAFAFA"
                      d="M22.44 4.3s2.54 5.14 3.18 9.49c.64 4.35-1.59 7.29-1.59 7.29l.06-5.18s-.7 5.98-4.68 10.95l-3.69-5.77s-2.77 4.84-2.64 8.01c0 0-4.68-4.09-3.46-10.55 0 0-1.82 1.85-1.95 3.3 0 0-6.46-5.54 0-17.54h14.77z"
                      opacity="0.2"
                    ></path>
                  </g>
                  <g id="Group">
                    <path
                      id="Path"
                      fill="#407BFF"
                      d="M19.5 81.18h20.69v4.51c0 .71-.58 1.29-1.29 1.29H20.8c-.71 0-1.29-.58-1.29-1.29v-4.51h-.01z"
                    ></path>
                    <path
                      id="Path"
                      fill="#FAFAFA"
                      d="M19.5 81.18h20.69v4.51c0 .71-.58 1.29-1.29 1.29H20.8c-.71 0-1.29-.58-1.29-1.29v-4.51h-.01z"
                      opacity="0.5"
                    ></path>
                    <path
                      id="Path"
                      fill="#407BFF"
                      d="M40.37 81.18H19.31s-7.39-39.56-4.22-56.01c1.3-6.74 4.39-12.48 7.6-16.9 1.66-2.3 3.36-4.24 4.84-5.79.49-.51.96-.97 1.39-1.39.51-.49 1.32-.49 1.83 0 .43.42.9.88 1.38 1.39 1.48 1.55 3.18 3.49 4.84 5.79 3.21 4.42 6.31 10.16 7.61 16.9 3.16 16.45-4.22 56.01-4.22 56.01h.01z"
                    ></path>
                    <circle id="Oval" cx="29.84" cy="34.36" r="10.15" fill="#FAFAFA" opacity="0.6"></circle>
                    <circle id="Oval" cx="29.84" cy="34.36" r="7.41" fill="#263238"></circle>
                    <g id="Path" fill="#263238">
                      <path
                        d="M43.14.42S55.4 3.73 58.17 12.63c1.93 6.19.31 13.99-.85 18.16-.27.96-1.58 1.04-1.98.13-1.87-4.33-6.43-12.17-14.98-12.75 0 0 0-2.58.7-8.61.74-6.42 2.08-9.15 2.08-9.15v.01zM16.53.42S4.27 3.73 1.5 12.63c-1.93 6.19-.31 13.99.85 18.16.27.96 1.58 1.04 1.98.13 1.87-4.33 6.43-12.17 14.98-12.75 0 0 0-2.58-.7-8.61-.74-6.42-2.08-9.15-2.08-9.15v.01z"
                        transform="translate(0 63)"
                      ></path>
                    </g>
                    <path
                      id="Path"
                      fill="#263238"
                      d="M29.84 63.42c1.46 0 2.64 1.18 2.64 2.64v26.16c0 1.29-1.05 2.34-2.34 2.34h-.59c-1.29 0-2.34-1.05-2.34-2.34V66.06c0-1.46 1.18-2.64 2.64-2.64h-.01zM36.98 8.27H22.69c1.66-2.3 3.36-4.24 4.84-5.79.49-.51.96-.97 1.39-1.39.51-.49 1.32-.49 1.83 0 .43.42.9.88 1.38 1.39 1.48 1.55 3.18 3.49 4.84 5.79h.01z"
                    ></path>
                  </g>
                </g>
                <g id="Path">
                  <path
                    fill="#263238"
                    d="M1.58 16.72c-2.85-4.69 1.88-8.52 4.5-5.9 0 0-3.18-5.97 3.94-9.33 7.12-3.36 10.81 2.36 10.81 5.04 0 0 1.58-6.43 9.49-5.04 7.91 1.39 7.61 10.27 7.61 10.27s2.66-6.67 11.12-4.2c0 0-.53-7.15 5.8-7.1 6.33.04 7.12 4.79 7.12 4.79s2.37-3.08 6.33.57 1.29 6.71 1.29 6.71 5.72-.7 5.38 4.18H1.58v.01z"
                    transform="translate(0 300)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M1.58 16.72c-2.85-4.69 1.88-8.52 4.5-5.9 0 0-3.18-5.97 3.94-9.33 7.12-3.36 10.81 2.36 10.81 5.04 0 0 1.58-6.43 9.49-5.04 7.91 1.39 7.61 10.27 7.61 10.27s2.66-6.67 11.12-4.2c0 0-.53-7.15 5.8-7.1 6.33.04 7.12 4.79 7.12 4.79s2.37-3.08 6.33.57 1.29 6.71 1.29 6.71 5.72-.7 5.38 4.18H1.58v.01z"
                    opacity="0.6"
                    transform="translate(0 300)"
                  ></path>
                  <path
                    fill="#FAFAFA"
                    d="M10.61 16.72s-2.18-3.99 2.18-7.12c4.35-3.13 9.1 1.28 9.1 1.28s.79-4.33 5.74-3.38c4.94.95 4.91 6.35 4.91 6.35s5.17-2.8 9.53 1.24c0 0 .59-3.85 4.15-4.85 3.56-1 6.18 2.42 6.18 2.42s-.07-4.87 4.98-5.53c5.06-.66 6.64 4.66 5.85 6.15 0 0 3.36.23 3.36 3.43H10.61v.01z"
                    opacity="0.4"
                    transform="translate(0 300)"
                  ></path>
                </g>
                <g id="Rectangle" fill="#000" opacity="0.2" transform="translate(86 80)">
                  <path d="M0.49 0.18H28.77V2.18H0.49z"></path>
                  <path d="M14.5 6.16H28.77V8.16H14.5z"></path>
                  <path d="M14.5 12.13H28.77V14.13H14.5z"></path>
                  <path d="M14.5 18.11H28.77V20.11H14.5z"></path>
                  <path d="M0.49 24.09H28.77V26.09H0.49z"></path>
                  <path d="M14.5 30.06H28.77V32.06H14.5z"></path>
                  <path d="M14.5 36.04H28.77V38.04H14.5z"></path>
                  <path d="M14.5 42.02H28.77V44.02H14.5z"></path>
                  <path d="M0.49 47.99H28.77V49.99H0.49z"></path>
                  <path d="M14.5 53.97H28.77V55.97H14.5z"></path>
                  <path d="M14.5 59.95H28.77V61.95H14.5z"></path>
                  <path d="M14.5 65.92H28.77V67.92H14.5z"></path>
                  <path d="M0.49 71.9H28.77V73.9H0.49z"></path>
                  <path d="M14.5 77.88H28.77V79.88H14.5z"></path>
                  <path d="M14.5 83.85H28.77V85.85H14.5z"></path>
                  <path d="M14.5 89.83H28.77V91.83H14.5z"></path>
                  <path d="M0.49 95.81H28.77V97.81H0.49z"></path>
                  <path d="M14.5 101.78H28.77V103.78H14.5z"></path>
                  <path d="M14.5 107.76H28.77V109.76H14.5z"></path>
                  <path d="M14.5 113.74H28.77V115.74H14.5z"></path>
                  <path d="M0.49 119.71H28.77V121.71H0.49z"></path>
                  <path d="M14.5 125.69H28.77V127.69H14.5z"></path>
                  <path d="M14.5 131.67H28.77V133.67H14.5z"></path>
                  <path d="M14.5 137.64H28.77V139.64H14.5z"></path>
                  <path d="M0.49 143.62H28.77V145.62H0.49z"></path>
                  <path d="M14.5 149.6H28.77V151.6H14.5z"></path>
                  <path d="M14.5 155.57H28.77V157.57H14.5z"></path>
                  <path d="M14.5 161.55H28.77V163.55H14.5z"></path>
                  <path d="M0.49 167.53H28.77V169.53H0.49z"></path>
                  <path d="M14.5 173.5H28.77V175.5H14.5z"></path>
                  <path d="M14.5 179.48H28.77V181.48H14.5z"></path>
                  <path d="M14.5 185.46H28.77V187.46H14.5z"></path>
                  <path d="M0.49 191.43H28.77V193.43H0.49z"></path>
                  <path d="M14.5 197.41H28.77V199.41H14.5z"></path>
                  <path d="M14.5 203.39H28.77V205.39H14.5z"></path>
                  <path d="M14.5 209.36H28.77V211.36H14.5z"></path>
                  <path d="M0.49 215.34H28.77V217.34H0.49z"></path>
                  <path d="M14.5 221.32H28.77V223.32H14.5z"></path>
                  <path d="M14.5 227.29H28.77V229.29H14.5z"></path>
                  <path d="M14.5 233.27H28.77V235.27H14.5z"></path>
                </g>
              </g>
            </g>
            <path id="Rectangle" fill="#FFF" d="M56 362H243V374H56z"></path>
            <g id="Shadow" fill="#F5F5F5" fillRule="nonzero" transform="translate(56 362)">
              <path
                id="Combined-Shape"
                d="M387.848 0a.71.71 0 01.042.24c0 6.252-86.808 11.32-193.89 11.32C86.918 11.56.11 6.492.11.24.11.16.124.08.152 0z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
